import { PageFactory } from 'src/factories/page';
import { AdvancedOrderedListFactory } from 'src/factories/advanced-ordered-list';
import { BulletListFactory } from 'src/factories/advanced-bullet-list';

import TranslateHelper from '../../../translations/translate-helper';

export function preloadTranslations () {
  window.INKIVE.TranslateHelper = new TranslateHelper(
    'editor',
    INKIVE.C.BASE_URL,
    'translations/client/',
    !INKIVE.C.IS_DEV && INKIVE.C.VERSION
  );

  window.INKIVE.TranslateHelper.translate = window.INKIVE.TranslateHelper.translate.bind(window.INKIVE.TranslateHelper);

  return INKIVE.TranslateHelper.load();
}

export function preloadVersionFile () {
  // Uses require to prevent desygner-api from failing
  const { instance: CompanyFactory } = require('../factory/company');
  CompanyFactory.initCache();
}

export function preloadUserData () {
  window.INKIVE.UserInfoFactory = require('../factory/user-info');
  INKIVE.UserInfoFactory.get();
}

// TODO: Refactor initialization of factories

export function initPageFactory () {
  window.INKIVE.PageFactory = window.INKIVE.PageFactory || new PageFactory();
}

export function initAdvancedOrderedListFactory () {
  window.INKIVE.AdvancedOrderedListFactory = window.INKIVE.AdvancedOrderedListFactory || new AdvancedOrderedListFactory();
}

export function initBulletListFactory () {
  window.INKIVE.BulletListFactory = window.INKIVE.BulletListFactory || new BulletListFactory();
}
